var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.538 16.483h10.917c1.456 0 2.242-.779 2.242-2.228V6.42c0-1.45-.786-2.235-2.242-2.235H4.538c-1.456 0-2.249.786-2.249 2.235v7.834c0 1.45.793 2.228 2.25 2.228Zm4.17-3.438c-.328.184-.71.014-.71-.321V7.966c0-.342.402-.506.71-.328l3.958 2.324a.451.451 0 0 1 0 .772l-3.958 2.31Z"
  })));
};
export default SvgPlay;